import { Update } from '@ngrx/entity';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { BaseOrderAction } from './order.action';
import { BaseOrderResponse, IAlgoOrderCreateRequest, IBaseAlgoOrder } from '../../../modules/order';

export const AlgoAction = createActionGroup({
	source: 'algo',
	events: {
		...BaseOrderAction,
		add: props<{ value: IBaseAlgoOrder }>(),
		set: props<{ value: IBaseAlgoOrder[] }>(),
		update: props<Update<IBaseAlgoOrder>>(),
		createAlgo: props<{ newValue: IBaseAlgoOrder; sendingValue: IAlgoOrderCreateRequest }>(),
		requestDone: props<{ value: BaseOrderResponse }>(),
		stopAlgo: props<{ id: string }>(),
		deletedAlgo: props<{ id: string }>(),
		loadHistory: emptyProps(),
		setHistory: props<{ value: IBaseAlgoOrder[] }>(),
		selectAlgo: props<{ id: string }>(),
		unSelectAlgo: emptyProps(),
		subscribeToLS: emptyProps()
	}
});
